import { FormSection, SectionHeader, ToggleWithDescription } from '../base';
import { UseFormReturn } from 'react-hook-form';
interface SmartQualifySectionProps {
  form: UseFormReturn<any>;
}

export const SmartQualifySection = ({ form }: SmartQualifySectionProps) => {
  return (
    <FormSection>
      <SectionHeader>Enable Smart Qualify</SectionHeader>
      <ToggleWithDescription form={form} name="smartQualify">
        Contextual AI qualifies the most valuable customers to send to Klaviyo using a combination
        of referring URL, demographic data, and site engagement metrics.
      </ToggleWithDescription>
    </FormSection>
  );
};
